/**
 * Copyright (c) 2022 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */

import { compact, sum } from 'lodash';
import { NotaryStatus } from 'blb-constants/ron';
const statusToText = {
  ACTIVE: 'Approved',
  EXPIRED: 'Expired',
  NEW: 'Invited',
  REJECTED: 'Rejected',
  TERMINATED: 'Terminated',
  UNDER_REVIEW: 'Under review'
};
export const mapGetUserListResponseToPipelineTopic = response => {
  const totalCount = response.totalCount;
  const topics = response.users.map(user => ({
    _id: user.id,
    assigneeIds: [],
    assignees: [],
    link: `/notary/${user.principalId}/dashboard`,
    properties: {
      'Notary.email': user.email || '',
      'Notary.name': compact([user.firstName, user.lastName]).join(' '),
      'Notary.phoneNumber': user.phoneNumber || '',
      'Notary.state': user.address?.stateCode || '',
      'Notary.status': user.status && statusToText[user.status]
    },
    text: ''
  }));
  return {
    topics,
    totalCount
  };
};
export const mapNotaryCountsByStatusResponseToPipelineTabs = response => {
  const countAll = sum(Object.values(response));
  // There will be refactors at RON side to update the list of status. The following is using old status value
  const tabs = [{
    filters: [],
    id: 'all',
    name: 'All notaries',
    subjectCount: countAll
  }, {
    filters: [],
    id: 'invited',
    name: 'Invited',
    subjectCount: response.NEW
  }, {
    filters: [],
    id: 'underReview',
    name: 'Under review',
    subjectCount: response.UNDER_REVIEW
  }, {
    filters: [],
    id: 'approved',
    name: 'Approved',
    subjectCount: response.ACTIVE
  }, {
    filters: [],
    id: 'rejected',
    name: 'Rejected',
    subjectCount: response.REJECTED
  }, {
    filters: [],
    id: 'terminated',
    name: 'Terminated',
    subjectCount: response.TERMINATED
  }, {
    filters: [],
    id: 'expired',
    name: 'Expired',
    subjectCount: response.EXPIRED
  }];
  return tabs;
};
const tabIdToUserStatus = {
  approved: NotaryStatus.ACTIVE,
  expired: NotaryStatus.EXPIRED,
  invited: NotaryStatus.NEW,
  rejected: NotaryStatus.REJECTED,
  terminated: NotaryStatus.TERMINATED,
  underReview: NotaryStatus.UNDER_REVIEW
};
export const mapTabIdToUserStatus = tabId => {
  return tabIdToUserStatus[tabId];
};